import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { changeFieldCheckType } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldCheckType } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';
import CheckTypeManualInputs from './CheckTypeManualInputs';
import CheckTypeQuiz from './CheckTypeQuiz';

// eslint-disable-next-line react/prefer-stateless-function
class CheckTaskInputs extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-undef
    $(`#collapseCheck`).collapse('show');
  }

  render() {
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupCheck"
          role="tablist"
        >
          <section className="panel panel-heading_padding-large panel-body_bg-sub panel-default">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseCheck"
                  aria-expanded="true"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseCheck"
                  role="button"
                >
                  <i className="fa fa-check-circle-o fa-fw" />{' '}
                  {t('Проверка задания')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseCheck"
              role="tabpanel"
              aria-expanded="true"
            >
              <div className="panel-body">
                <form>
                  <div className="form-group">
                    <label className="control-label" htmlFor={'radio1'}>
                      {t('Тип проверки')}
                    </label>
                    <div className="control-group" id="typeCheck">
                      <div
                        className="radio abc-radio"
                        data-target="#manual-check"
                      >
                        <input
                          defaultChecked={
                            this.props.fieldCheckType.value === '1'
                          }
                          onChange={() => this.props.changeFieldCheckType('1')}
                          id="radio1"
                          name="radio1"
                          type="radio"
                          value="1"
                        />
                        <label htmlFor="radio1">
                          <div className="text-strong m-b-4">
                            {this.props.taskCheckTypes[1]}
                          </div>
                          {t(
                            'Выполнение проверяется вручную согласно описанию в текущем задании'
                          )}
                        </label>
                      </div>
                      <div
                        className="radio abc-radio"
                        data-target="#auto-check"
                      >
                        <input
                          defaultChecked={
                            this.props.fieldCheckType.value === '2'
                          }
                          onChange={() => this.props.changeFieldCheckType('2')}
                          id="radio2"
                          name="radio1"
                          type="radio"
                          value="2"
                        />
                        <label htmlFor="radio2">
                          <div className="text-strong m-b-4">
                            {this.props.taskCheckTypes[2]}
                          </div>
                          {t(
                            'Проверка и оплата выполнения происходит по ключевому слову, в виде вопроса-ответа'
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                  {this.props.fieldCheckType.value === '1' ? (
                    <CheckTypeManualInputs {...this.props} />
                  ) : (
                    <CheckTypeQuiz {...this.props} />
                  )}
                </form>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

CheckTaskInputs.propTypes = {
  fieldCheckType: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldCheckType: PropTypes.func.isRequired,
  taskCheckTypes: PropTypes.shape({}).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldCheckType: selectFieldCheckType(state, props.reducerName),
  taskCheckTypes: getItemFromRefList(state, 'taskCheckTypes')
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldCheckType: value =>
    dispatch(changeFieldCheckType(props.reducerName, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTaskInputs.js